import { HttpParams } from '@angular/common/http';

export const appendToParam = (params: HttpParams, key: string, separator: string, newItem: string): HttpParams => {
  const param = params.get(key) ?? '';
  const paramUpdated = [...param.split(separator).filter((v) => !!v), newItem].join(separator);
  return params.set(key, paramUpdated);
};
